export default __webpack_public_path__ + "static/media/img63.7086d277.jpg";